
import dayjs from "dayjs";
import { getProjectDetail } from "@/api/enterprise";
import { getToken } from "@/utils/auth";

export default {
  components: {},
  props: ["project_id", "fileName"],
  data() {
    return {
      optionszuobiaoxi: [
        {
          label: "大地2000",
          value: "GJ2000",
        },
        {
          label: "高德坐标系",
          value: "GD",
        },
      ],
      selectVal: "GJ2000",
      layerLoading: false,
    };
  },
  mounted() {},
  methods: {
    async save() {
      const res = await getProjectDetail({ project_id: this.project_id });
      var params = new URLSearchParams();
      params.append("wkt", res.data.project_data);
      params.append("coordinate_system", this.selectVal);
      fetch(`/api/export_dxf`, {
        method: "POST",
        headers: {
          token: getToken(),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params.toString(),
      })
        .then((response) => {
          if (response.ok) {
            return response.blob();
          } else {
            throw new Error("Error: " + response.statusText);
          }
        })
        .then((blob) => {
          var fileName = `${this.fileName}-${dayjs().format(
            "YYYY年MM月DD日 HH时mm分ss秒"
          )}.dxf`;
          saveAs(blob, fileName);
          this.$layer.closeAll();
        })
        .catch((error) => {
          this.layerLoading = false;
          this.$layer.closeAll();
        });
    },
  },
};
